<template>
  <div class="second-menu">
    <el-menu
      :default-active="this.$route.matched[2].path"
      class="el-menu-vertical-demo"
      background-color="#ebedf1"
      text-color="#606266"
      :default-openeds="openeds"
      :router="true"
    >
      <div v-for="(value,index) in menu" :key="index">
        <el-submenu :index="value.url" v-if="value.childrenMenu.length>0">
          <template slot="title">
            <span>{{value.menuName}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              :index="child.url"
              v-for="(child,index) in value.childrenMenu"
              :key="index"
            >{{child.name}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item :index="value.url" v-else>
          <span slot="title">{{value.menuName}}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { getDBOperationPermission } from "common/js/storage";
export default {
  props: {
    secondaryMenuMap: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      menu: [],
      openeds: [],
      authorityList: [],
      state1: false, // 当前二级路由判断并跳转
      state2: false, // 当前三级路由判断并跳转
    };
  },
  watch: {
    $route: function (newVal, oldVal) {
      if (newVal.redirectedFrom) {
        if (newVal.redirectedFrom.split("/").length === 3) {
          if (this.menu[0].childrenMenu.length > 0) {
            this.$router.push(this.menu[0].childrenMenu[0].url);
          } else {
            this.$router.push(this.menu[0].url);
          }
        }
      }
    },
  },
  beforeMount() {
    // 获取权限数据
    if (getDBOperationPermission() === "") {
      setTimeout(() => {
        this.authorityList = getDBOperationPermission();
        this.reconstruction();
      }, 1000);
    } else {
      this.authorityList = getDBOperationPermission();
      this.reconstruction();
    }
  },
  mounted() {
    this.menu = this.secondaryMenuMap;
    for (let i = 0; i < this.secondaryMenuMap.length; i++) {
      this.openeds.push(this.secondaryMenuMap[i].url);
    }
    // 阻止刷新返回第一条
    let path = this.$route.matched[2].path;
    for (let j = 0; j < this.menu.length; j++) {
      if (this.menu[j].childrenMenu.length === 0) {
        if (this.menu[j].url === path) {
          this.state1 = true;
          return;
        } else {
          this.state1 = false;
        }
      } else if (this.menu[j].childrenMenu.length > 0) {
        for (let k = 0; k < this.menu[j].childrenMenu.length; k++) {
          if (this.menu[j].childrenMenu[k].url === path) {
            this.state2 = true;
            return;
          } else {
            this.state2 = false;
          }
        }
      }
    }
    if (!this.state1 && !this.state2) {
      if (this.menu[0].childrenMenu.length > 0) {
        this.$router.push(this.menu[0].childrenMenu[0].url);
      } else {
        this.$router.push(this.menu[0].url);
      }
    }
  },
  methods: {
    reconstruction() {
      // 根据权限重铸导航栏
      for (let i = 0; i < this.secondaryMenuMap.length; i++) {
        if (this.secondaryMenuMap[i].keyword) {
          if (
            this.authorityList.indexOf(this.secondaryMenuMap[i].keyword) === -1
          ) {
            this.secondaryMenuMap.splice(i, 1);
            i = i - 1;
          } else {
            if (this.secondaryMenuMap[i].childrenMenu.length > 0) {
              for (
                let j = 0;
                j < this.secondaryMenuMap[i].childrenMenu.length;
                j++
              ) {
                if (
                  this.secondaryMenuMap[i].childrenMenu[j].keyword &&
                  this.authorityList.indexOf(
                    this.secondaryMenuMap[i].childrenMenu[j].keyword
                  ) === -1
                ) {
                  this.secondaryMenuMap[i].childrenMenu.splice(j, 1);
                  j = j - 1;
                }
              }
            }
          }
        } else {
          if (this.secondaryMenuMap[i].childrenMenu.length > 0) {
            for (
              let j = 0;
              j < this.secondaryMenuMap[i].childrenMenu.length;
              j++
            ) {
              if (
                this.authorityList.indexOf(
                  this.secondaryMenuMap[i].childrenMenu[j].keyword
                ) === -1
              ) {
                this.secondaryMenuMap[i].childrenMenu.splice(j, 1);
                j = j - 1;
              }
            }
            if (this.secondaryMenuMap[i].childrenMenu.length === 0) {
              this.secondaryMenuMap.splice(i, 1);
              i = i - 1;
            }
          }
        }
      }
    },
  },
};
</script>
<style lang='scss'>
.second-menu {
  .el-menu {
    border: 0;
    .el-submenu {
      .el-submenu__title {
        width: 120px;
        padding: 0 !important;
        text-align: center;
        line-height: 40px;
        height: 40px;
        background: #ebedf1 !important;
        .el-submenu__icon-arrow {
          right: 12px;
        }
      }
      .el-menu {
        width: 120px;
        .el-menu-item-group {
          .el-menu-item-group__title {
            width: 0px;
            padding: 0;
          }
          > ul {
            width: 120px;
            .el-menu-item {
              width: 120px !important;
              padding-left: 10px !important;
            }
          }
        }
      }
    }
    .el-menu-item {
      padding: 0 !important;
      height: 40px;
      min-width: 120px;
      line-height: 40px;
      text-align: center;
      padding: 0;
    }
  }
  .el-menu-item.is-active {
    background: rgba(245, 247, 250, 1) !important;
    color: rgb(96, 98, 102);
  }
  .el-menu-item:hover {
    background: #ebedf1 !important;
    color: #3d74f2 !important;
  }
  .el-menu-item.is-active:hover {
    background: rgba(245, 247, 250, 1) !important;
    color: #606266 !important;
  }
}
</style>
